import styled from '@emotion/styled';
import {
  ButtonNav,
  ContentCompact,
  DividerHorizontal,
  Form,
  HeaderFunnel,
  InputSearch,
  Section,
  TextHeading2,
  token,
} from '@ferreri/prever-component-lib';
import { LinkWrapper } from '@ferreri/prever-component-lib/nextjs';
import Fuse from 'fuse.js';
import { useRouter } from 'next/router';
import { ComponentProps, useMemo } from 'react';
import * as yup from 'yup';

import { ActionsSection } from './ActionsSection';
import { FAQ } from './faq-data';

const schema = yup.object().shape({
  q: yup.string().trim().required(),
});

type FormData = yup.InferType<typeof schema>;

export const Faq = () => {
  const router = useRouter();
  const options = useMemo(() => {
    const array = Object.entries(FAQ).map(([path, data]) => {
      return { path, ...data };
    });

    const fuse = new Fuse(array || [], {
      keys: ['data.question', 'data.answer'],
      includeMatches: true,
    });

    const filter = router.query.q as string;

    if (filter && router.isReady) {
      return fuse.search(filter).map((data) => {
        return data.item;
      });
    }

    return array;
  }, [router.query.q, router.isReady]);

  const handleSubmit = (data: FormData) => {
    router.replace({ query: data });
  };

  const handleClear = () => {
    router.replace('/');
  };

  if (!router.isReady) {
    return null;
  }

  return (
    <>
      <ContentCompact>
        <HeaderFunnel onClickArrow={router.back}>Atendimento</HeaderFunnel>
        <Section>
          <TextHeading2>Como podemos te ajudar?</TextHeading2>
        </Section>
        <Section>
          <Form
            schema={schema}
            onSubmit={handleSubmit as ComponentProps<typeof Form>['onSubmit']}
            defaultAsyncValues={router.query}
            defaultValues={router.query}
          >
            <InputSearch
              name="q"
              placeholder="Digite sua dúvida"
              onClear={handleClear}
            />
          </Form>
          <Content>
            {options?.map(({ path, category }, index) => {
              const isFirst = index === 0;
              const href = `/faq/${path}`;

              if (isFirst) {
                return (
                  <LinkWrapper href={href} key={category}>
                    <ButtonNav label={category} />
                  </LinkWrapper>
                );
              }

              return (
                <>
                  <DividerHorizontal />
                  <LinkWrapper href={href}>
                    <ButtonNav label={category} />
                  </LinkWrapper>
                </>
              );
            })}
          </Content>
        </Section>
      </ContentCompact>
      <ActionsSection />
    </>
  );
};

const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxSmall};
`;
